import React, { useState, useEffect } from "react"
import { Label } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import ServiceBookingModal from "./serviceBookingModal"
import ConfirmModal from "components/Common/ConfirmModal"
import { cancelServiceBookings, getServiceType } from "../../../store/actions"
import moment from "moment"
import { PAYMENT_STATUS } from "constants/common"
import DataTable from "react-data-table-component"


const UpcomingService = () => {
  const dispatch = useDispatch()
  const [selectedServiceBooking, setSelectedServiceBooking] = useState(null)
  const [showServiceBookingModal, setServiceBookingModal] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const upcomingServiceList = useSelector(
    state => state.ServiceReducer.upcomingServices
  )
  let serviceType = useSelector(state => state.ServiceReducer.serviceType)
  let addressList = useSelector(state => state.Profile.address)

  useEffect(() => {
    if (!serviceType?.length) {
      dispatch(getServiceType())
    }
  }, [])

  const getServiceName = serviceId => {
    let serviceObj = serviceType.find(item => item.id === serviceId)
    return serviceObj && serviceObj.serviceType ? serviceObj.serviceType : "-"
  }
  const getAddressTag = addressId => {
    let addressObj = addressList.find(item => item.id === addressId)
    return addressObj && addressObj.tags ? addressObj.tags : "-"
  }

  const cancelServiceBooking = serviceInfo => {
    dispatch(
      cancelServiceBookings({
        ...serviceInfo,
        serviceStatus: "CANCELLED",
      })
    )
  }
  const getPaymentStatus = status => {
    if (status === PAYMENT_STATUS.PAID) {
      return "Paid"
    } else if (status === PAYMENT_STATUS.PENDING || status === "PENDING") {
      return "Pending"
    } else if (status === PAYMENT_STATUS.PARTIALLY_PAID) {
      return "Partially Paid"
    } else if (status === PAYMENT_STATUS.REFUND_PENDING) {
      return "Refund Pending"
    } else if (status === PAYMENT_STATUS.REFUND_INITIATED) {
      return "Refund Initiated"
    } else if (status === PAYMENT_STATUS.REFUND_COMPLATED) {
      return "Refunded"
    } else {
      return "-"
    }
  }

  let columns = [
    {
      id: 1,
      name: "Service",
      selector: item => item.serviceID,
      format: item => getServiceName(item.serviceID),
      sortable: true,
      reorder: true,
    },
    {
      id: 2,
      name: "Date",
      selector: item => item.dateTimeFrom,
      format: item =>
        moment(item.dateTimeFrom).isValid()
          ? moment.utc(item.dateTimeFrom).local().format("DD/MM/YYYY hh:mm A")
          : "-",
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: "Duration",
      selector: row => row.duration,
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      id: 4,
      name: "Address",
      selector: item => item.serviceAddressID,
      format: item => getAddressTag(item.serviceAddressID),
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      id: 5,
      name: "Description",
      selector: row => row.description,
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      id: 6,
      name: "Payment Status",
      selector: item => item.paymentStatus,
      format: item => getPaymentStatus(item.paymentStatus),
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      id: 7,
      name: "Action",
      selector: item => (
        <ul className="list-inline mb-0 font-size-20">
          <li className="list-inline-item">
            <i
              className="bx bxs-edit-alt text-success"
              onClick={() => {
                setSelectedServiceBooking(item)
                setServiceBookingModal(true)
              }}
              id="editService"
            ></i>
          </li>
          <li className="list-inline-item">
            <i
              className="bx bxs-trash text-danger"
              onClick={() => {
                setSelectedServiceBooking(item)
                setShowConfirmModal(true)
              }}
              id="cancelService"
            ></i>
          </li>
        </ul>
      ),
      sortable: true,
      // right: true,
      reorder: true,
    },
  ]

  return (
    <React.Fragment>
      {upcomingServiceList.length > 0 && (
        <DataTable
          noHeader
          // title="Senior Citizen"
          columns={columns}
          data={upcomingServiceList}
          defaultSortFieldId={2}
          // sortIcon={<SortIcon />}
          pagination
          highlightOnHover
          // selectableRows
        />
      )}
      {upcomingServiceList.length === 0 && <Label>No bookings found</Label>}
      {selectedServiceBooking && (
        <ServiceBookingModal
          isOpen={showServiceBookingModal}
          selectedService={
            serviceType.filter(
              item => item.id === selectedServiceBooking.serviceID
            )[0]
          }
          data={selectedServiceBooking}
          closeModal={() => {
            setServiceBookingModal(false)
          }}
          onSubmitClick={() => {
            setServiceBookingModal(false)
          }}
          onCancelClick={() => {
            setServiceBookingModal(false)
          }}
        />
      )}
      <ConfirmModal
        isOpen={showConfirmModal}
        titleText="Booking cancellation"
        bodyText="Are you sure you want to cancel booking"
        onYesClick={() => {
          cancelServiceBooking(selectedServiceBooking)
          setShowConfirmModal(false)
        }}
        onNoClick={() => {
          setShowConfirmModal(false)
        }}
      />
    </React.Fragment>
  )
}

export default UpcomingService
